export const BASE_VALUE = `USDC`;